import { withInstall } from '@/utils'
import DetailCard from './src/detailCard.vue'
export default withInstall(DetailCard)
